import Loading from "vue-loading-overlay";

export default {
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            sliderData: [],
            pageCMS: [],
            cmsData: [],
            sliderImagePath: this.$api + "upload/sell_bulk_slider/",
            cmsImagePath: this.$api + "upload/sell_bulk/",
            cmsHeaderImagePath: this.$api + "upload/sell_bulk_slider/",
            productDetails: [
                {
                    productName: "",
                    quantity: "",
                    condition: "",
                    category: ""
                }
            ],
            input: [],
            name: "",
            company: "",
            email: "",
            phone: "",
            comments: "",
            type: "",
            selectFile: undefined,
            cssPullPathforImageHeader: '',

        }
    },
    created() {
        document.title = "Geek Buy Back - Sell In Bulk";
        this.getSliderData();
        this.getCMS();

        let jqueryScript = document.createElement('script')
        jqueryScript.setAttribute('src', '/jquery.min.js')
        document.head.appendChild(jqueryScript)

        let bootstrapScript = document.createElement('script')
        bootstrapScript.setAttribute('src', '/bootstrap.bundle.min.js')
        document.head.appendChild(bootstrapScript)
    },
    methods: {
        getSliderData: function() {
            this.isLoading = true;
            var configs = {
                method: "GET",
                url: this.$api + this.$config.bulk.getSellInBulkSliderURL
            };
            this.$axios(configs).then((response) => {
                if(response.data.status == "success") {
                    this.sliderData = response.data.data;
                    this.pageCMS = response.data.pageCMS;
                    this.cssPullPathforImageHeader="#717171 url("+this.cmsHeaderImagePath+response.data.data.slider_background+") no-repeat center bottom !important;";

                    //document.getElementsByClassName('sell_in_bulk_banner').css("background",cssPullPathforImageHeader);
                    //$(".sell_in_bulk_banner").css("background",cssPullPathforImageHeader);
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        },
        getCMS: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + this.$config.bulk.getSellInBulkCMS
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.cmsData = response.data.data;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        },
        addProduct: function(index) {
            this.productDetails.push({ 
                productName: "", 
                quantity: "",
                condition: "",
                category: ""
            });
            console.log(index);
        },
        deleteProduct: function(index) {
            this.productDetails.splice(index, 1);
        },
        onFileChange(event) {
            this.selectFile = event.target.files[0];
        },
        submitSellInBulk: function() {
            this.isLoading = true;
            let selectType = this.type;
            let SiteConfig={};
            if(selectType == "uploadFile") {
                const formData = new FormData();
                formData.append("name", this.name);
                formData.append("company", this.company);
                formData.append("email", this.email);
                formData.append("phone", this.phone);
                formData.append("comments", this.comments);
                formData.append("type", this.type);
                formData.append("files", this.selectFile);

                SiteConfig = {
                    method: "POST",
                    url: this.$api + this.$config.bulk.storeSellInBulkProductURL,
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                };
            }
            else if(selectType == "formData") {
                const data = {
                    name: this.name,
                    company: this.company,
                    email: this.email,
                    phone: this.phone,
                    comments: this.comments,
                    productDetails: this.productDetails,
                    type: this.type
                };

                SiteConfig = {
                    method: "POST",
                    url: this.$api + this.$config.bulk.storeSellInBulkProductURL,
                    data: data
                };
            }
            this.$axios(SiteConfig).then((response) => {
                if(response.data.status == "success") {
                    this.$swal.fire({
                        icon: "success",
                        text: "Thank You, Your request has been sent successfully. Our concern team will communicate shortly."
                    });
                    this.type=null;
                    this.name = '';
                    this.email = '';
                    this.company = '';
                    this.phone = '';
                    this.comments = '';
                    this.productDetails=[
                        {
                            productName: "",
                            quantity: "",
                            condition: "",
                            category: ""
                        }
                    ];
                    this.$refs.inputFile.value = null;
                    
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        }
    }
}